import React from "react";

import HStack from "../hstack/hstack";

interface FormActionsProps {
  children: React.ReactNode;
}

/** Container element to house form actions. */
const FormActions: React.FC<FormActionsProps> = ({ children }) => (
  <HStack space={2} justifyContent="end">
    {children}
  </HStack>
);

export default FormActions;
